import ModalPortal from "../../Assets/ModalPortal/ModalPortal"
import { useEffect, useState } from "react"
import LocalizedLink from "../../../hoc/LocalizedLink"
import SelectLang from "../../SelectLang/SelectLang"
import AuthModalLogin from "./AuthModalLogin"
import AuthModalCode from "./AuthModalCode"
import AuthModalReg from "./AuthModalReg"
import clsx from "clsx"
import Button from "../../Assets/Button/Button"
import { useTranslation } from "react-i18next"
import { useAppSelector } from "../../../hooks"
import { selectParams } from "../../../redux/slice/params"
import { LANGUAGES } from "../../../utils/constants"
import styles from "./AuthModal2.module.scss"

const AuthModal2 = () => {
  const { t } = useTranslation("translation", { keyPrefix: `interface` })
  const { companyLogo } = useAppSelector(selectParams)

  const [isOpen, setOpen] = useState<boolean>(true)
  const [step, setStep] = useState<number>(1)
  const [seconds, setSeconds] = useState<number>(0)
  const [phoneNumber, setPhoneNumber] = useState<string>("")
  const [email, setEmail] = useState<string>("")
  const [isEmail, setIsEmail] = useState<boolean>(false)

  useEffect(() => {
    let interval: any = null
    if (step === 2 && seconds && seconds > 0) {
      interval = setInterval(() => {
        setSeconds((sec: number) => sec - 1)
      }, 1000)
    }
    return () => clearInterval(interval)
  }, [step, seconds])

  return (
    <ModalPortal className={styles.modal} isOpen={isOpen} setIsOpen={setOpen}>
      {companyLogo.data && (
        <div className={styles.header}>
          <LocalizedLink to={"/"} className={styles.logo}>
            {companyLogo.type === "image/svg+xml" ? (
              <span dangerouslySetInnerHTML={{ __html: companyLogo.data }} />
            ) : (
              <img src={companyLogo.data} alt={"logo"} />
            )}
          </LocalizedLink>
          {LANGUAGES?.length > 0 && <SelectLang className={styles.lang} />}
        </div>
      )}

      <p className={styles.logoTxt}>
        powered by {process.env.REACT_APP_PUBLIC_PROJECT_TYPE === "digitask" ? "Digitask" : "Staq"}
      </p>

      {step === 1 ? (
        <AuthModalLogin
          setStep={setStep}
          setSeconds={setSeconds}
          phoneNumber={phoneNumber}
          setPhoneNumber={setPhoneNumber}
          isEmail={isEmail}
          setIsEmail={setIsEmail}
          email={email}
          setEmail={setEmail}
        />
      ) : step === 2 ? (
        <AuthModalCode
          setStep={setStep}
          setSeconds={setSeconds}
          phoneNumber={phoneNumber}
          seconds={seconds}
          setOpen={setOpen}
          isEmail={isEmail}
          email={email}
        />
      ) : step === 3 ? (
        <AuthModalReg setStep={setStep} setOpen={setOpen} />
      ) : null}
      {/* Окошко ошибки */}
      {(step === 10 || step === 11) && (
        <>
          <div className={clsx(`modal-head`, styles.authHead)}>
            <div className={`modal-title`}>
              {step === 11 ? t("numberIsBlocked") : isEmail ? t("emailNotFound") : t("numberNotFound")}
            </div>
          </div>
          <div className={`modal-text`}>
            {step === 11 ? t("accIsBlocked") : isEmail ? t("authTextEmail3") : t("authText3")}
          </div>
          <div className={clsx("modal-bottom", styles.authBottom, styles["authBottom--center"])}>
            <Button txt={t("back")} onClick={() => setStep(1)} mode={"gray"} />
          </div>
        </>
      )}
    </ModalPortal>
  )
}

export default AuthModal2
